import * as React from 'react';

const SVGClose: React.SFC<SvgProps> = props => (
  <svg width={12} height={12} {...props}>
    <g
      strokeWidth={2}
      stroke="#000"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.528 1.265l-9.35 9.35M10.528 10.614l-9.35-9.35" />
    </g>
  </svg>
);

export default SVGClose;
